import { gql } from 'apollo-angular';

export const getSharedContentFields = `
    folderId
    folderName
    documents {
        id
        name
        extension
        sharedWithMeAt
        unread
    }
    folders {
      id
      name
      unreadDocumentCount
    }
    breadcrumbs {
        id
        name
    }
    shouldSeeMigrationModal
`;

export const getUnreadQuery = gql`
  query getUnread {
    getUnread {
      documents
      ticketsWithUnreadMessages {
        damage
        concern
      }
      unreadDocuments {
        contractIds
        contractless
      }
      unreadTicketMessages {
        contractIds
        contractless
        archivedContractIds
        archivedContractless
      }
    }
  }
`;

export const getSharedContentQuery = gql`
  query getSharedContent($input: SharedFolderContentRequestBean!) {
    getSharedContent (input: $input) {
      ${getSharedContentFields}
    }
  }
`;

export const migrateDocumentsMutation = gql`
  mutation migrateDocuments($markAsRead: Boolean!) {
    migrateDocuments(markAsRead: $markAsRead)
  }
`;
